if (!customElements.get('product-inventory-status')) {
  customElements.define(
    'product-inventory-status',
    class ProductInventoryStatus extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.container = this.querySelector('[data-product-inventory-container]');
        this.onOptionChange = this.onOptionChange.bind(this);

        if (!this.sectionId || !this.container) return;

        this.sectionEl = document.getElementById('ProductSection-' + this.sectionId);
        if (!this.sectionEl) return;

        this.optionSelectorClass = 'single-option-selector-' + this.sectionId;
        this.masterSelectId = 'ProductSelect-' + this.sectionId;
        this.productData = this.getProductData();

        this.sectionEl.addEventListener('change', this.onOptionChange);
      }

      disconnectedCallback() {
        if (!this.sectionEl) return;
        this.sectionEl.removeEventListener('change', this.onOptionChange);
      }

      getProductData() {
        const productJson = document.getElementById('ProductJson-' + this.sectionId);
        if (!productJson) return null;

        try {
          return JSON.parse(productJson.textContent);
        } catch (error) {
          return null;
        }
      }

      getCurrentVariant() {
        if (!this.productData || !this.productData.variants) return null;

        const selectors = this.sectionEl.querySelectorAll('.' + this.optionSelectorClass);

        if (!selectors.length) {
          return this.productData.variants[0] || null;
        }

        const selectedOptions = [];

        selectors.forEach((element) => {
          if (element.type === 'radio' || element.type === 'checkbox') {
            if (!element.checked) return;
            selectedOptions.push({
              index: element.dataset.index,
              value: element.value,
            });
            return;
          }

          selectedOptions.push({
            index: element.dataset.index,
            value: element.value,
          });
        });

        return (
          this.productData.variants.find((variant) =>
            selectedOptions.every(
              (option) => variant[option.index] === option.value
            )
          ) || null
        );
      }

      onOptionChange(event) {
        const target = event.target;
        const isOptionSelector = target.classList.contains(this.optionSelectorClass);
        const isMasterSelect = target.id === this.masterSelectId;

        if (!isOptionSelector && !isMasterSelect) return;

        if (isMasterSelect) {
          const variant = this.productData?.variants?.find(
            (item) => String(item.id) === String(target.value)
          );
          this.updateInventoryStatus(variant || null);
          return;
        }

        this.updateInventoryStatus(this.getCurrentVariant());
      }

      updateInventoryStatus(variant) {
        if (!this.container) return;

        if (!variant || !variant.available) {
          this.container.innerHTML = '';
          this.classList.add('hide');
          return;
        }

        const template = this.querySelector(
          '[data-product-inventory-template="' + variant.id + '"]'
        );

        if (!template) {
          this.container.innerHTML = '';
          this.classList.add('hide');
          return;
        }

        this.container.innerHTML = '';
        this.container.appendChild(template.content.cloneNode(true));

        if (this.container.querySelector('[data-product-inventory-item]')) {
          this.classList.remove('hide');
        } else {
          this.classList.add('hide');
        }
      }
    }
  );
}
